module.exports = __webpack_public_path__ + "img/douyin_logo.33d6c43a.png";